import api from '../../utils/api'

import { useEffect, useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormClient from './Form/FormClient'

function EditClient({ id, btCancelAction, handleOnSuccess }) {
    const [client, setClient] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {

        api.get(`/client/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            setClient(response.data.client)
        })
    }, [token, id])

    async function updateClient(client) {
        let msgType = 'success'


        const data = await api.patch(`client/${client._id}`, client, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            handleOnSuccess()
        }

    }


    return (
        client.name && (
            <FormClient title="Editar Cliente" handleSubmit={updateClient} btnText="Salvar" btCancelAction={btCancelAction} clientData={client} />
        )
    )
}

export default EditClient
